import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BitradexWithdrawal from "../pages/bitradex-withdrawal/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/bitradex-withdrawal",
    element: <BitradexWithdrawal />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
